'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _WidgetRequest = require('./WidgetRequest');

var _WidgetRequest2 = _interopRequireDefault(_WidgetRequest);

var _WidgetResponse = require('./WidgetResponse');

var _WidgetResponse2 = _interopRequireDefault(_WidgetResponse);

var _WidgetWindowBridge = require('./WidgetWindowBridge');

var _WidgetWindowBridge2 = _interopRequireDefault(_WidgetWindowBridge);

var _InitPropertiesBag = require('./InitPropertiesBag');

var _InitPropertiesBag2 = _interopRequireDefault(_InitPropertiesBag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextMessageId = 0;
var nextCorrelationId = 0;

/**
 * Various factory methods
 *
 * @class
 */

var WidgetFactories = function () {
  function WidgetFactories() {
    (0, _classCallCheck3.default)(this, WidgetFactories);
  }

  (0, _createClass3.default)(WidgetFactories, null, [{
    key: 'windowBridgeFromGlobals',

    /**
     * Creates a communication bridge between the a widget and the `window` object if in a browser environment
     *
     * @static
     * @method
     *
     * @return {WidgetFactories.windowBridgeFromWindow}
     */
    value: function windowBridgeFromGlobals() {
      if (window) {
        return new WidgetFactories.windowBridgeFromWindow(window);
      }

      throw new Error('could not find a global window object');
    }

    /**
     * Creates a communication bridge between the a widget and the `window` object
     *
     * @static
     * @method
     *
     * @param {Window} windowObject
     * @return {WidgetWindowBridge}
     * @throws Error
     */

  }, {
    key: 'windowBridgeFromWindow',
    value: function windowBridgeFromWindow(windowObject) {
      var initProps = _InitPropertiesBag2.default.fromWindow(windowObject);
      if (_InitPropertiesBag2.default.validate(initProps)) {
        return new _WidgetWindowBridge2.default(windowObject, initProps);
      }

      throw new Error('invalid or missing init properties');
    }

    /**
     * Parse an object literal or a JSON encoded string into a {@link WidgetResponse} or a {@link WidgetRequest}
     *
     * @static
     * @method
     *
     * @param {{}|string} raw
     * @return {WidgetMessage}
     */

  }, {
    key: 'parseMessageFromJS',
    value: function parseMessageFromJS(raw) {
      var status = raw.status;


      if (status) {
        return _WidgetResponse2.default.parse(raw);
      }

      return _WidgetRequest2.default.parse(raw);
    }

    /**
     * Creates a new request
     *
     * @static
     * @method
     *
     * @param {string} widgetId
     * @param {*} payload
     * @return {WidgetRequest}
     */

  }, {
    key: 'nextRequest',
    value: function nextRequest(widgetId, payload) {
      var correlationId = ++nextCorrelationId;
      var id = ++nextMessageId;

      return new _WidgetRequest2.default({ id: id.toString(), widgetId: widgetId, correlationId: correlationId.toString(), body: payload });
    }
  }, {
    key: 'nextResponse',


    /**
     * Creates the response message for a request
     *
     * @static
     * @method
     *
     * @param {WidgetRequest} request the initial request
     * @param {*} body response body
     * @param {boolean} isError true when the response is an error response
     * @return {WidgetResponse}
     */
    value: function nextResponse(request, body, isError) {
      var id = ++nextMessageId;
      var widgetId = request.widgetId,
          correlationId = request.correlationId;

      var status = isError ? 'error' : 'success';

      //const parsedBody = body === null ? body : JSON.stringify(body);
      return new _WidgetResponse2.default({ id: id.toString(), widgetId: widgetId, correlationId: correlationId.toString(), body: body, status: status });
    }
  }]);
  return WidgetFactories;
}();

exports.default = WidgetFactories;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Widget/WidgetFactories.js
// module id = 97
// module chunks = 0